import { render, staticRenderFns } from "./ChooseButtonWrapper.vue?vue&type=template&id=50588652&scoped=true"
import script from "./ChooseButtonWrapper.vue?vue&type=script&lang=js"
export * from "./ChooseButtonWrapper.vue?vue&type=script&lang=js"
import style0 from "./ChooseButtonWrapper.vue?vue&type=style&index=0&id=50588652&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50588652",
  null
  
)

export default component.exports